import { render, staticRenderFns } from "./ShipmentsOverview.vue?vue&type=template&id=4cf537f9&"
import script from "./ShipmentsOverview.vue?vue&type=script&lang=js&"
export * from "./ShipmentsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports